module.exports = App.Advert = DS.Model.extend
  # timestamps
  created_at: DS.attr 'date'
  updated_at: DS.attr 'date'

  organization: DS.belongsTo 'organization', async: true

  name:              DS.attr 'string'
  text:              DS.attr 'string'
  action:            DS.attr 'string'
  link:              DS.attr 'string'
  preview_link:      DS.attr 'string'
  short_sid:         DS.attr 'string'

  promo :            DS.belongsTo 'promo', async: true

  is_private:        DS.attr 'boolean'

  send_push:         DS.attr 'boolean'
  send_sms:          DS.attr 'boolean'
  send_sms_fallback: DS.attr 'boolean'
  send_whatsapp:     DS.attr 'boolean'

  push_text:         DS.attr 'string'
  push_title:        DS.attr 'string'
  sms_text:          DS.attr 'string'
  whatsapp_text:     DS.attr 'string'
  vk_text:           DS.attr 'string'
  telegram_text:     DS.attr 'string'


  photo:             DS.attr 'mixed'
  recurrence:        DS.attr 'mixed'

  status:            DS.attr 'mixed'

  is_archived:       DS.attr 'boolean'
  send_auto:         DS.attr 'boolean'

  actual_from:  DS.attr 'date'
  actual_till:  DS.attr 'date'
  scheduled_at: DS.attr 'date'

  was_orders_after:   DS.attr 'date'
  was_orders_before:  DS.attr 'date'
  no_orders_after:    DS.attr 'date'
  no_orders_before:   DS.attr 'date'

  delivery_status:    DS.attr 'string'

  restaurants:         DS.hasMany   'restaurant',   async: true
  client_tags:         DS.hasMany   'client_tag',   async: true
  except_client_tags:  DS.hasMany   'client_tag',   async: true


  client_tag_ids:     DS.attr      'mixed'
  except_client_tag_ids: DS.attr   'mixed'

  availableRecurrence: (->
    arr = []
    rec = @get('recurrence')
    window.RECURRENCE_TYPES.forEach (recurrence, i) =>
      arr.push {id: recurrence, name: Em.I18n.t("clients.recurrence_filter.#{recurrence}"), selected: (rec && rec.indexOf(recurrence) > -1) }
    arr
  ).property('recurrence')


  humanizedСreatedAt: (->
    createdAt = @get('created_at')
    return unless createdAt
    moment(createdAt).format('DD.MM.YYYY')
  ).property('created_at')

  availableRecurrenceObserver: (->
    v = @get('availableRecurrence')
      .filter (r) -> r.selected
      .map (r) -> r.id
    @set('recurrence', v)
  ).observes('availableRecurrenceUpdate')

  execute: (client_id)->
    @nonRESTAction('POST', 'execute')

  cancel: (client_id)->
    @nonRESTAction('POST', 'cancel')

  getStatistics: ()->
    @nonRESTAction('GET', 'statistics')

  uploadPhoto: (file) ->
    promise = @fileUpload('photo', file)
    promise.then => @notifyRecordChange()
    promise

  # Фото для карточки в списке
  cardBackgroundStyle: (->
    photo = @get('photo.medium')
    result = if photo then "background-image:  url(#{photo});" else ''
    result.htmlSafe()
  ).property('photo.medium_square')
